import React, {useState} from "react"

import {PageContentInterface} from "../page-content-interface"
import AttachmentsCollection from "../../../../../core/model2/attachment/attachments"
import PageControlsContent from "./controls-content"

type Props = {
    app             : PageContentInterface

    attachments?    : AttachmentsCollection
}

// const debug = "PageControls"
const debug = false

export default function PageControls(props:Props) {

    const [isPopoverShown, setIsPopoverShown] = useState(false)

    const onTogglePopover = (value: boolean) => {
        setIsPopoverShown(value)
    }

    const classes = Classes("page-controls flex-row-left-center h-30", {
        'popover-shown': isPopoverShown
    })

    return (
        <div className={classes}>
            <PageControlsContent app                = {props.app}
                                 onTogglePopover    = {onTogglePopover}/>
        </div>
    )
}